export const MOBILE_WIDTH = 600;
export const NORMAL_WIDTH = 900;
export const FRAME_WIDTH = 32;
export const ROW_LIMIT = 7;
export const SEAT_WIDTH = 64;
export const SEAT_SMALLWIDTH = 58;

export const SeatType = {
    EMPTY: -1,
    SEAT: 0,
    AISLE: 1,
};

export const Scales = {
    MEDIUM: 0.7,
    SMALL: 0.5,
};
